import React, { Fragment } from "react";
import styled from "styled-components";
import cx from "classnames";
import TotalBet from "../TotalBet";
// lib
import { createSymbol } from "../../../config/replace";
import { useSelector } from "react-redux";
import { getData } from "common-lib/lib";
// config
import { currencyList } from "../../../config/currencyList";

export const PayTableWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const PayList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  text-align: left;
  flex-wrap: wrap;
  & .half {
    width: 100%;
    margin: 0 2%;
    display: flex;
    flex-direction: row;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${(props) => (props.isLongList ? "40px" : "-5px")};
    flex: 1;
    @media (min-width: 700px) {
      width: 50%;
    }
    @media (min-width: 1024px) {
    }
    & .pic {
      /* width: 40%;   */
      padding: 20px 0;
      text-align: right;
      .pay-img {
        width: 130px;
        height: 130px;
        image-rendering: -webkit-optimize-contrast;
      }
    }
    & .list {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 24px;
      margin-left: 10px;
      & > div {
        margin: 3px 0;
        white-space: nowrap;
      }
      & span {
        font-size: 24px;
        color: #fff;
        /* margin-left: 5px; */
      }
    }
  }
`;
const Normal = ({
  lang,
  windowDimensions,
  payTableData,
  gameId,
  isCurrency,
  currency,
  denom,
  betLevel,
  moneyConvert,
  symbol,
  bet,
  isLongList,
}) => {
  const imgsdomain = useSelector((state) => state.props.imgsdomain);
  const matchData = getData(payTableData, ["math_data"], []);
  return (
    <PayTableWrapper>
      <TotalBet
        lang={lang}
        isCurrency={isCurrency}
        currency={currency}
        bet={bet}
        denom={denom}
      />
      {/* <p className="title">{translation["payTable"][lang]}</p> */}
      <PayList windowDimensions={windowDimensions} isLongList={isLongList}>
        {matchData.length === 0 ? (
          <div className="half">No PayTable Data</div>
        ) : (
          matchData
            .filter(
              (i) =>
                !getData(i, ["SymbolPays"]).every((v) => v === 0) &&
                getData(i, ["SymbolName"]) !== "SC" &&
                getData(i, ["SymbolName"]) !== "W" &&
                getData(i, ["SymbolName"]) !== "F" &&
                getData(i, ["SymbolName"]) !== "W1" &&
                getData(i, ["SymbolName"]) !== "W2" &&
                getData(i, ["SymbolName"]) !== "W3" &&
                getData(i, ["SymbolName"]) !== "W4" &&
                getData(i, ["SymbolName"]) !== "W5"
            )
            .map((v) => {
              const reverseData = []
                .concat(getData(v, ["SymbolPays"]))
                .reverse();
              return (
                <div className="half" key={getData(v, ["SymbolID"])}>
                  <div className="pic">
                    <img
                      className={cx("pay-img object-fit-scale", {
                        bigSymbol: symbol.some(
                          (i) => i === getData(v, ["SymbolName"])
                        ),
                        mobileSize: windowDimensions.width < 375,
                      })}
                      alt=""
                      src={`${imgsdomain}/vp_project/common/${gameId}/symbolList/${getData(
                        v,
                        ["SymbolName"]
                      )}.png`}
                    />
                  </div>
                  <div className="list">
                    {reverseData.map(
                      (v, k, array = getData(v, ["SymbolPays"])) => (
                        <Fragment key={k}>
                          {v !== 0 && (
                            <div key={k}>
                              {array.length - k}
                              <span> - </span>
                              <span className={cx({ money: isCurrency })}>
                                {isCurrency && (
                                  <div
                                    className="symbol"
                                    dangerouslySetInnerHTML={createSymbol(
                                      currencyList[currency]["symbol"],
                                      imgsdomain
                                    )}
                                  />
                                )}
                                {isCurrency
                                  ? moneyConvert(v * denom * betLevel)
                                  : v * betLevel}
                              </span>
                            </div>
                          )}
                        </Fragment>
                      )
                    )}
                  </div>
                </div>
              );
            })
        )}
      </PayList>
    </PayTableWrapper>
  );
};

export default Normal;
